import React from "react";

const Pay = () => {
  return (
    <div>
      <h1 className="welcome-dashboard">Payment system coming soon</h1>
    </div>
  );
};

export default Pay;
